import React from "react";
import { Text, StyleSheet } from "react-native";

import defaultStyles from "../config/styles";

function AppText({
  children,
  style,
  color = "white",
  textColor = "black",
  opacity = 1,
  ...otherProps
}) {
  return (
    <Text
      style={[
        // defaultStyles.text,
        style,
        {
          backgroundColor: defaultStyles.colors[color],
          color: defaultStyles.colors[textColor],
          opacity: opacity,
          // fontSize: 16,
          // fontFamily: "Avenir",
        },
      ]}
      {...otherProps}
    >
      {children}
    </Text>
  );
}

export default AppText;
